import React from "react";
import "../../css/Common.css";

/**
 * Inline share form that replaces the fixed-position FamilySharingModal
 * on mobile scam detector views.
 *
 * Renders inline below the threat banner: success message, or
 * textarea + Cancel / Share with Family buttons.
 *
 * @param {Object} props
 * @param {boolean}  props.shareSuccess  - Whether the share was successful
 * @param {string|null} props.shareError - Error message, if any
 * @param {string}   props.shareMessage  - Current textarea value
 * @param {Function} props.setShareMessage - Setter for textarea value
 * @param {boolean}  props.shareLoading  - Whether a share request is in-flight
 * @param {Function} props.onCancel      - Called when Cancel is pressed
 * @param {Function} props.onSend        - Called when Share with Family is pressed
 */
const InlineShareForm = ({
  shareSuccess,
  shareError,
  shareMessage,
  setShareMessage,
  shareLoading,
  onCancel,
  onSend,
}) => {
  return (
    <div className="sasm-inline-share">
      {shareSuccess ? (
        <div className="sasm-inline-share-success">
          <span>✓</span> Alert shared with your family!
        </div>
      ) : (
        <>
          <p className="sasm-inline-share-info">
            Share this scam alert with your family group.
          </p>
          {shareError && (
            <div className="sasm-inline-share-error">{shareError}</div>
          )}
          <textarea
            className="sasm-inline-share-input"
            placeholder="Add a message (optional)..."
            value={shareMessage}
            onChange={(e) => setShareMessage(e.target.value)}
            maxLength={500}
            rows={2}
          />
          <div className="sasm-inline-share-actions">
            <button
              className="sasm-inline-share-cancel"
              onClick={onCancel}
              disabled={shareLoading}
            >
              Cancel
            </button>
            <button
              className="sasm-inline-share-send"
              disabled={shareLoading}
              onClick={onSend}
            >
              {shareLoading ? "Sharing..." : "Share with Family"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default InlineShareForm;
